import { PublicClientApplication } from "@azure/msal-browser";
import { getCwhMsalController } from "@ingka-group-digital/cwh-msal-controller";
import { msalConfiguration } from "@coworker/apprestructured/src/assets/auth/msalConfig";

export const msalPublicClientApplication = (async () => {
  const msalInstance = new PublicClientApplication(
    msalConfiguration,
    getCwhMsalController(msalConfiguration)
  );

  await msalInstance.initialize();
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0] ?? null);
  }

  return msalInstance;
})();
